import { zeroPad } from '@/shared/lib';

/**
 * Names the PDF file for one return shipping label of a study. Interpolates the study id zero-padded to five digits and the one-based label index into the 'Study_..._Return_Label....pdf' template.
 *
 * @param index - Zero-based index of the label within the study.
 * @param id - Study id.
 * @returns Filename for the study return label PDF.
 */
const formatShippingLabel = (index: any, id: any) =>
  `Study_${zeroPad(id, 5)}_Return_Label${index + 1}.pdf`;

export default formatShippingLabel;
